import { Reveal } from "@/components/Reveal";

const SHOTS = [
  {
    src: "https://images.unsplash.com/photo-1772466431674-2eccb0be32da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxjcmFmdCUyMGNvY2t0YWlsJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzkxMjE2MzY3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Red craft cocktail on a dark bar",
    span: "md:col-span-2 aspect-[16/10]",
  },
  {
    src: "https://images.unsplash.com/photo-1562049070-7e003d30a3d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwZXZlbnQlMjBkcmlua3N8ZW58MHx8fHwxNzkxMjE2MzY3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Elegant glass at a luxury event",
    span: "aspect-[3/4]",
  },
  {
    src: "https://images.unsplash.com/photo-1778104959337-5260c89e2293?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxjb2NrdGFpbCUyMGRhcmslMjBtb29keSUyMGJhcnxlbnwwfHx8fDE3OTEyMTY2OTJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Cocktail with orange peel on a bar counter",
    span: "aspect-square md:mt-14",
  },
  {
    src: "https://images.unsplash.com/photo-1770282184757-3a5ab6aa872f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxjcmFmdCUyMGNvY2t0YWlsJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzkxMjE2MzY3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Tall cocktail with fresh garnish",
    span: "aspect-[3/4]",
  },
  {
    src: "https://images.unsplash.com/photo-1772311698901-fe3fa07141be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxjb2NrdGFpbCUyMGRhcmslMjBtb29keSUyMGJhcnxlbnwwfHx8fDE3OTEyMTY2OTJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Three colorful cocktails on a dark reflective surface",
    span: "md:col-span-2 aspect-[16/10]",
  },
  {
    src: "https://images.unsplash.com/photo-1699730148588-42aabafe9c72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxmcmllbmRzJTIwdG9hc3RpbmclMjBjb2NrdGFpbHMlMjBwYXJ0eXxlbnwwfHx8fDE3OTEyMTY2OTJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Friends toasting with cocktails at a private party",
    span: "aspect-square",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal className="mb-14">
          <p className="eyebrow mb-5">Gallery</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#F5F5F5]">
            Poured with <em className="italic text-[#D98B48]">intent</em>.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {SHOTS.map((shot, i) => (
            <Reveal key={shot.src} delay={(i % 3) * 0.08} className={shot.span.startsWith("md:col-span-2") ? "md:col-span-2" : ""}>
              <div className={`group overflow-hidden border border-white/10 ${shot.span.replace("md:col-span-2 ", "")}`} data-testid={`gallery-image-${i + 1}`}>
                <img
                  src={shot.src}
                  alt={shot.alt}
                  loading="lazy"
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700 will-change-transform"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
